import { authClient } from "@superadmin/utils/auth.client";
import { Typography } from "@voicely/ui-mui/data-display/Typography";
import { Alert } from "@voicely/ui-mui/feedback/Alert";
import { Button } from "@voicely/ui-mui/form/Button";
import { Box } from "@voicely/ui-mui/layout/Box";
import { Container } from "@voicely/ui-mui/layout/Container";
import { Paper } from "@voicely/ui-mui/layout/Paper";
import { Stack } from "@voicely/ui-mui/layout/Stack";

/**
 * Signed in, not an operator. Rendered as words rather than a bare 403:
 * whoever lands here holds a working account and needs to know the account is
 * the problem, not the sign-in. Rotating the allowlist is a backend env
 * change (`SUPER_ADMIN_EMAILS`) and a redeploy.
 */
export const DeniedPage = () => {
	const handleSignOut = async () => {
		await authClient.signOut();
		window.location.href = "/auth/login";
	};

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				px: 2,
				bgcolor: "surface.canvas",
			}}
		>
			<Container maxWidth="xs">
				<Paper variant="outlined" sx={{ p: 4, borderRadius: 4 }}>
					<Stack spacing={3}>
						<Typography variant="h4">Not an operator</Typography>
						<Alert severity="warning">
							This account is signed in but is not on the super-admin allowlist. If it should be, an
							operator has to add it to
							<code> SUPER_ADMIN_EMAILS</code> and redeploy the backend.
						</Alert>
						<Button variant="outlined" onClick={handleSignOut}>
							Sign in with a different account
						</Button>
					</Stack>
				</Paper>
			</Container>
		</Box>
	);
};
